import React, { } from 'react'
import { useSelector } from 'react-redux'
import ProjectPageCRUD from '../components/projects/ProjectPageCRUD';
import { Navigate } from 'react-router-dom'

const ProjectPage = () => {
    const userLogin = useSelector((state) => state.userLogin)
    return (

        <>
            {userLogin && userLogin.todoUserInfo && Object.keys(userLogin.todoUserInfo).length>0?
                <ProjectPageCRUD /> :
                <Navigate to="/login" replace={true} />}


        </>
    )
}
export default ProjectPage
